// extracted by mini-css-extract-plugin
export default {"counter":"SalesGoalCounter_counter__U-Wl3","value":"SalesGoalCounter_value__PvuSZ","range":"SalesGoalCounter_range__RxgHb","status":"SalesGoalCounter_status__n6113"};